/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SortInDir = typeof SortInDir[keyof typeof SortInDir];


export const SortInDir = {
  asc: 'asc',
  desc: 'desc',
} as const;
